import * as React from 'react';

import * as style from './SearchResultPlug.css';

export const SearchResultPlug: React.FC = () => {
  return <div className={style['container']}>Ничего не найдено</div>;
};
